// ============================================================
// Domain-Aufteilung: auth.webgis.* meldet an, app.webgis.* arbeitet.
// Alles wird aus dem AKTUELLEN Host abgeleitet — keine Env, kein Build-
// Unterschied. Auf ungeteilten Hosts (dev.webgis, localhost, Alt-Domain)
// sind beide Fragen "nein" und nichts aendert sein Verhalten.
// ============================================================

/** Laeuft die App gerade auf dem Anmelde-Host (auth. / auth-dev.)? */
export function aufAnmeldeHost(): boolean {
  return /^auth(-dev)?\./.test(location.hostname);
}

/** Laeuft die App auf dem geteilten App-Host (app. / app-dev.)? */
export function aufAppHost(): boolean {
  return /^app(-dev)?\./.test(location.hostname);
}

/** Der App-Host zum aktuellen Anmelde-Host (auth-dev -> app-dev). */
export function appUrsprung(): string {
  return `${location.protocol}//${location.hostname.replace(/^auth/, "app")}`;
}

/** Der Anmelde-Host zum aktuellen App-Host (app-dev -> auth-dev). */
export function anmeldeUrsprung(): string {
  return `${location.protocol}//${location.hostname.replace(/^app/, "auth")}`;
}

/**
 * Die Landing zum aktuellen Host: app.webgis.* / auth.webgis.* -> webgis.*.
 *
 * Nur "app."/"auth." OHNE -dev wird abgeschnitten. Wie die Landing auf den
 * Vorschau-Hosts heisst, steht nirgends im Code (landing.js erkennt "-dev."
 * nur an sich selbst), und ein geratener Name waere ein toter Link. Auf
 * ungeteilten Hosts — localhost, -dev, Alt-Domain — bleibt der Name deshalb
 * unveraendert; dort ist die Wurzel ohnehin die Landing.
 */
export function landingUrsprung(): string {
  return `${location.protocol}//${location.hostname.replace(/^(app|auth)\./, "")}/`;
}
